import { render, staticRenderFns } from "./FrameView.vue?vue&type=template&id=3ae79158&scoped=true"
import script from "./FrameView.vue?vue&type=script&lang=js"
export * from "./FrameView.vue?vue&type=script&lang=js"
import style0 from "./FrameView.vue?vue&type=style&index=0&id=3ae79158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae79158",
  null
  
)

export default component.exports